/*  TWO COLUMNS WITH IMAGE ( https://tailwindui.com/components/marketing/sections/content-sections#component-39249d619dcd4a64f3089bf550369572 )  */

import React, { useContext } from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import FluidImage from "src/utils/FluidImage";
import Button from "src/components/Button";
import { TitleColour, BoldColour } from "src/utils/ColourUtilities";
import { PageContext } from "src/utils/context";
import SetCookie from "src/utils/SetCookie";

const TwoColumnsWithImage = ({ blok }) => {
  const { setCtaReferrer, name } = useContext(PageContext);

  const handleClick = (value) => {
    setCtaReferrer(value);
    SetCookie(`gated_content_redirect_url=${blok.button_target.cached_url}`);
  };

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div
        className={`${
          blok.grey_bg ? "bg-midgrey py-9 md:py-24" : "bg-white my-9 md:my-24"
        } overflow-hidden`}
      >
        <div
          className={`relative flex flex-col md:flex-row ${
            blok.flip_content ? "md:flex-row-reverse" : ""
          } mx-auto max-w-7xl items-center lg:px-8 px-6`}
        >
          <div
            className={`w-full lg:w-3/5 ${
              blok.flip_content ? "md:ml-12" : "md:mr-12"
            }`}
          >
            <div className="relative text-base lg:max-w-none">
              <figure>
                <FluidImage
                  className="object-cover object-center"
                  image={blok.image}
                />
                <figcaption className="text-grey mt-3 flex text-sm italic">
                  <span className="ml-2">{blok.photo_by}</span>
                </figcaption>
              </figure>
            </div>
          </div>
          <div className="w-full lg:w-2/5">
            <div className="mt-6 mb-7 text-base md:mb-6 lg:my-0">
              {blok.gated_content ||
              blok.content_type === "webinar" ||
              blok.content_type === "podcast" ? (
                <>
                  <h1
                    className={`font-display text-4xl font-normal uppercase leading-8 tracking-tight ${BoldColour(
                      blok.colour
                    )} md:text-5xl`}
                  >
                    <RichText>{blok.title}</RichText>
                  </h1>
                  <h1
                    className={`font-display text-4xl font-normal uppercase leading-8 tracking-tight ${TitleColour(
                      blok.colour
                    )} md:text-5xl`}
                  >
                    <RichText>{blok.sub_title}</RichText>
                  </h1>
                </>
              ) : (
                <>
                  <h2
                    className={`font-display text-4xl font-normal uppercase leading-8 tracking-tight ${BoldColour(
                      blok.colour
                    )} md:text-5xl`}
                  >
                    <RichText>{blok.title}</RichText>
                  </h2>
                  <h2
                    className={`font-display text-4xl font-normal uppercase leading-8 tracking-tight ${TitleColour(
                      blok.colour
                    )} md:text-5xl`}
                  >
                    <RichText>{blok.sub_title}</RichText>
                  </h2>
                </>
              )}
            </div>
            <div className="mt-8 lg:mt-0">
              <div className="text-sm md:mx-auto md:max-w-prose lg:max-w-none">
                <div className="text-lg text-gray-500">
                  <RichText>{blok.intro_copy}</RichText>
                </div>
                <div className="prose text-darkgrey border-red mx-auto mt-5 border-l-2 lg:max-w-none">
                  <span className="block pl-4 text-sm">
                    <RichText>{blok.content}</RichText>
                  </span>
                </div>
                {!blok.free_event && blok.button_label ? (
                  <Button
                    className="bg-red hover:bg-darkred mt-4 py-[20px]"
                    target={
                      // If not gated content
                      !blok.gated_content
                        ? blok.button_target.cached_url
                        : "/gated-content/"
                    }
                    blank={
                      blok.gated_content
                        ? false
                        : blok.button_target.linktype !== "story"
                        ? true
                        : false
                    }
                    onClick={
                      blok.gated_content
                        ? () => handleClick(`${name}`)
                        : ""
                    }
                  >
                    {blok.button_label}
                  </Button>
                ) : blok.free_event && !blok.button_label ? (
                  <Button
                    className="bg-red hover:bg-darkred mt-4 py-[20px]"
                    target={"/event-signup/"}
                    onClick={() => setCtaReferrer(`${name}`)}
                  >
                    Register for event
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default TwoColumnsWithImage;
